import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-size: 14px;
    font-weight: 400;
    font-family: Arial,sans-serif;
  }
  .smallFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
  }
  .smallBoldFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
  }
  .standardFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0;
    text-align: left;
  }
  .standardBoldFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0;
  }
  .middleFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }
  .middleBoldFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }
  .largeFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0;
    text-align: left;
  }
  .largeBoldFont {
    font-family: "Hiragino Kaku Gothic Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: 0;
    text-align: left;
  }
  .extraLargeFont {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0;
    text-align: left;
  }
  .ant-modal-header {
    background-color: #80A445;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .ant-modal-title {
    text-align: center;
    font-family: "Hiragino Kaku Gothic Pro";
    font-size: 18px;
    font-style: normal;
    color: white;
    font-weight: 700;
    line-height: 39px;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-body {
    padding-bottom: 0px;
  }
  .ant-modal-footer {
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: none;
  }
  .ant-modal-footer > .ant-btn-link {
    height: 60px!important;
    width: 240px!important;
    background-color: #dddddd!important;
    color: white;
    border: 1px solid #dddddd!important;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  }
  .ant-modal-footer > .ant-btn-text {
    height: 60px;
    width: 139px;
    background-color: #dddddd!important;
    color: white;
    border: 1px solid #dddddd!important;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  }
  .ant-modal-footer > .ant-btn-primary {
    height: 60px!important;
    width: 240px!important;
    background-color: #ff8a00!important;
    border: 1px solid #ff8a00!important;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  }
      .ant-modal-footer .ant-btn {
    height: 60px;
    width: 139px;
    background-color: #c4c4c4;
    border: 1px solid #c4c4c4;
    color: white;
    border-radius: 5px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  }
  .clinic-room {
    text-align: center;
    background: white;
    border-radius: 24px;
    padding: 10px;
    color: black;
    margin-bottom: 1.5rem;
  }
  .upload-file-bill {
    text-align: center;
    border: 3px #b5b5b5;
    border-style: dashed;
    height: 235px;
    background-color: #d8d8d8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .svg {
    width: 80px;
    height: 55px;
    color: #c4c4c4;
    font-size: 55px;
  }
  .anticon-message > svg {
    width: 17px !important;
    height: 17px !important;
  }
  .anticon-message > svg:hover {
    color: #ff8a00;
  }
  .ant-tooltip-inner {
    color: black !important;
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
  }
  .btnDefault, .ant-btn:focus {
    background-color: #ff8a00;
    color: white;
    border:none;
    border-radius: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2)
  }
  .btnDefault:hover {
    background: #FFFFFF !important;
    border: 1px solid #ff8a00 !important;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    color: #ff8a00 !important;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .pr-0 {
    padding-right: 0;
  }
  .pl-0 {
    padding-left: 0;
  }
  .pb-0 {
    padding-bottom: 0;
  }
  .d-flex {
    display: flex;
  }
  .alignCenter {
    display: flex;
    align-items: center;
  }
  .ml-5px {
    margin-left: 5px;
  }
  .ant-tooltip-inner {
    color: #ff8a00 !important;
  }
  .ant-pagination-item {
    background: #C4C4C4 !important;
    margin-right: 1px !important;
    margin-left: 1px !important;
    border-radius: 50% ;
    border: none;
    a {
      color: white;
      :hover {
        color: white;
      }
    }
  }
  .ant-pagination-item-active {
    background: #000000 !important;
    border-radius: 50% ;
    border: none;
    a {
      :hover {
        color: white;
      }
      color: white;
    }
  }
  .ant-pagination-item-ellipsis {
    color: black !important;
    font-size: 10px;
  }
  .ant-pagination-item-link {
    background: #80A445 !important;
    border-radius: 50% !important;
    :hover {
      border: none;
    }
    svg {
      color: white;
    }
  }
  .ant-table-thead {
    .ant-table-cell {
      color: white;
      background: black;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .spaceBetween {
    justify-content: space-between;
  }
  .bar {
    border-left: 1px solid #000000;
    margin: 0 10px;
    height: 30px;
  }
  .mt-7 {
    margin-top: 7px;
  }
  .ant-form-item textarea {
    resize: none;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-5 {
    margin-right: 5px ;
  }
  .mr-10 {
    margin-right: 10px ;
  }
  .mr-24 {
    margin-right: 24px;
  }
  .pt-5 {
    padding-top: 5px;
  }
  .errors {
    border: 1px solid #FFCCC7;
    background: #FFF1F0;
    color: #FF0000;
    padding: 5px;
    margin-bottom: 30px
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .ant-layout-header {
    z-index: 999;
  }
  .ant-tooltip {
    z-index: 0;
  }
  .ant-table-thead {
    .ant-checkbox {
      display: none;
    }
  }
  .modal {
    .ant-btn {
      box-shadow: 0 3px 6px rgb(0 0 0 / 25%);
      border-radius: 5px !important;
    }
    .ant-btn[disabled], .ant-btn[disabled]:hover, .ant-btn[disabled]:focus, .ant-btn[disabled]:active {
      color: rgba(0, 0, 0, 0.25);
      background: #f5f5f5 !important;
      border-color: #d9d9d9 !important;
      text-shadow: none !important;
      box-shadow: none !important;
    }
    .ant-table-thead {
      .ant-table-cell {
        text-align: center;
      }
    }
    .ant-table-tbody {
      .ant-table-row-selected {
        .ant-table-cell {
          background: #ECFFB8 !important;
        }
      }
      .ant-table-cell {
        :first-child {
          background: rgba(246, 246, 246, 1);
        }
        
      }
    }
  }
  .anticon-search > svg {
    width: 18px;
    height: 18px;
  }
  .ant-switch-checked {
    background-color: #80a445;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
      .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
      .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
        background: #80a445 !important;
      }
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border: 1px solid white !important;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
    border-color: #80a445 !important;
  }
  .ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
    color: #80a445 !important;
    border-right-color: #80a445 !important;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: #80a445 !important;
    color: #80a445 !important;
    border-left-color: #80a445 !important;
  }
  .ant-upload.ant-upload-drag {
    border: none;
  }
  .ant-spin-dot-item {
    background: #80a445;
  }
  .ant-spin-lg .ant-spin-dot {
    width: 40px;
    height: 40px;
  }
  .error {
    background-color: rgba(255, 241, 240, 1);
    border: 1px solid rgba(255, 204, 199, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      color: rgba(255, 0, 0, 1);
    }
    p {
      margin: 7px 5px;
      color: rgba(255, 0, 0, 1);
    }
  }
  .error-upload {
    margin-top: 10px;
    color: red;
  }
  .white-space {
    white-space: pre-wrap;
  }
`;

export default GlobalStyle;
